export default __webpack_public_path__ + "static/advocacy-1bd66db29b4fb364f41fabfaa07893d0.png";